export default "__VITE_ASSET__hmou7mf$__"